import * as React from "react";
// import { pure } from 'recompose';
import * as cx from "classnames";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { onClickBurger, activeBurger, navigationAuthorization } = props;

  /**
   * @description : La couleur des boutons pour le menu
   * @const
   * @type { string }
   * @name fillBurger0
   */
  const fillBurger0: string = activeBurger[0] ? "#00ECBC" : "#007ADF";

  /**
   * @description : La couleur des boutons pour le menu
   * @const
   * @type { string }
   * @name fillBurger1
   */
  const fillBurger1: string = activeBurger[1] ? "#00ECBC" : "#007ADF";

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <span className="burgerNavigationMenu">
      <div
        className={cx("list-burger   left", {
          "active-dots": activeBurger[0],
          "not-allowed-autho": !navigationAuthorization,
        })}
        onClick={navigationAuthorization ? onClickBurger(0) : "undefined"}
      >
        <div className="burger-dots">
          <svg
            width="18"
            height="25"
            viewBox="0 0 449 449"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M280.625 168.375H168.375V280.625H280.625V168.375Z"
              fill={navigationAuthorization ? fillBurger0 : "#b7b5b5"}
            />
            <path
              d="M112.25 0H0V112.25H112.25V0Z"
              fill={navigationAuthorization ? fillBurger0 : "#b7b5b5"}
            />
            <path
              d="M280.625 336.75H168.375V449H280.625V336.75Z"
              fill={navigationAuthorization ? fillBurger0 : "#b7b5b5"}
            />
            <path
              d="M112.25 168.375H0V280.625H112.25V168.375Z"
              fill={navigationAuthorization ? fillBurger0 : "#b7b5b5"}
            />
            <path
              d="M112.25 336.75H0V449H112.25V336.75Z"
              fill={navigationAuthorization ? fillBurger0 : "#b7b5b5"}
            />
            <path
              d="M449 0H336.75V112.25H449V0Z"
              fill={navigationAuthorization ? fillBurger0 : "#b7b5b5"}
            />
            <path
              d="M280.625 0H168.375V112.25H280.625V0Z"
              fill={navigationAuthorization ? fillBurger0 : "#b7b5b5"}
            />
            <path
              d="M449 168.375H336.75V280.625H449V168.375Z"
              fill={navigationAuthorization ? fillBurger0 : "#b7b5b5"}
            />
            <path
              d="M449 336.75H336.75V449H449V336.75Z"
              fill={navigationAuthorization ? fillBurger0 : "#b7b5b5"}
            />
          </svg>
        </div>
      </div>
      <div
        className={cx("list-burger  left", {
          "active-dots": activeBurger[1],
          "not-allowed-autho": !navigationAuthorization,
        })}
        onClick={navigationAuthorization ? onClickBurger(1) : " undefined"}
      >
        <div className="burger-lists">
          <svg
            width="25"
            height="25"
            viewBox="0 0 833 833"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 694.167H833V583.463H0V694.167ZM0 462.778H833V352.074H0V462.778ZM0 120.685V231.389H833V120.685H0Z"
              fill={navigationAuthorization ? fillBurger1 : "#b7b5b5"}
            />
          </svg>
        </div>
      </div>
    </span>
  );
};

// initialisation des props
Component.defaultProps = {
  activeBurger: [true, false],
};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  activeBurger: boolean[];
  onClickBurger: any;
  navigationAuthorization?: boolean;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/onglet-burger/component.tsx